
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="relative bg-gradient-to-r from-orange-dark to-orange-primary rounded-2xl sm:rounded-3xl overflow-hidden"
        >
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="w-full h-full" style={{
              backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(0,0,0,0.1) 35px, rgba(0,0,0,0.1) 70px)',
            }}></div>
          </div>

          {/* Content */}
          <div className="relative z-10 py-12 sm:py-20 px-6 sm:px-8 md:px-16 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-4 break-words"
            >
              ¿Listo para tu proyecto de pladur?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-10"
            >
              Presupuesto sin compromiso en 24h
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center"
            >
              <Link
                to="/contacto"
                className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-orange-primary rounded-full hover:scale-105 hover:shadow-2xl transition-all duration-300 font-bold text-base sm:text-lg whitespace-nowrap inline-flex items-center justify-center space-x-2"
              >
                <i className="ri-mail-line"></i>
                <span>Solicitar presupuesto</span>
              </Link>
              <a
                href="https://wa.me/34629501941"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-full hover:bg-white hover:text-orange-primary transition-all duration-300 font-bold text-base sm:text-lg whitespace-nowrap inline-flex items-center justify-center space-x-2"
              >
                <i className="ri-whatsapp-line"></i>
                <span>Enviar WhatsApp</span>
              </a>
            </motion.div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={inView ? { opacity: 1 } : {}}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="text-white/70 text-xs sm:text-sm mt-6 sm:mt-8"
            >
              Atendemos en Badalona, Barcelona y alrededores · <Link to="/faq" className="underline hover:text-white">Ver preguntas frecuentes</Link>
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
